export const APPLICATIONS_PATH_NAME = 'applications';
